<template>
  <div class="contentBox">
    <navBox :id="navId"  ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox" ref="scrollContainer" v-if="addType">
        <div class="write-txt">
          <p class="write-title">选择类型<span>*</span></p>
          <div class="write-text">
            <el-select v-model="addObj.speech_type" placeholder="请选择" @change="speechSub">
              <el-option
                v-for="item in typelist"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <span>请选择</span>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">选择演讲方式<span>*</span></p>
          <div class="write-text">
            <el-select v-model="addObj.type" placeholder="请选择" @change="typeSub">
              <el-option
                v-for="item in promptlist"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <span>请选择</span>
          </div>
        </div>

        <div v-if="addObj.speech_type == 1" style="display:block;">
          <div v-if="addObj.type == 1" style="display:block;">
            <div class="write-txt write-item">
              <div class="write-title">
                演讲简易报告提示词--中文<span>*</span>
                <div class="write-btnlist">
                  <button class="btn btn-test" @click="testPrompt('111')">测试提示词</button>
                  <button class="btn btn-history" @click="historyPrompt('111')">历史测试</button>
                </div>
              </div>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.ai_prompt_simple"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
            <div class="write-txt write-item">
              <div class="write-title">
                演讲完整报告提示词--中文<span>*</span>
               <div class="write-btnlist">
                  <button class="btn btn-test" @click="testPrompt('112')">测试提示词</button>
                  <button class="btn btn-history" @click="historyPrompt('112')">历史测试</button>
                </div>
              </div>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.ai_prompt"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
            <div class="write-txt" v-for="(item,index) in addObj.dimension" :key="index">
              <p class="write-title">维度{{(index+1)}}中文<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.dimension[index]"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>

            <div class="write-txt write-item">
              <div class="write-title">
                演讲简易报告提示词--英文<span>*</span>
                <div class="write-btnlist">
                  <button class="btn btn-test" @click="testPrompt('121')">测试提示词</button>
                  <button class="btn btn-history" @click="historyPrompt('121')">历史测试</button>
                </div>
              </div>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.ai_prompt_simple_english"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
            <div class="write-txt write-item">
              <div class="write-title">
                演讲完整报告提示词--英文<span>*</span>
                <div class="write-btnlist">
                  <button class="btn btn-test" @click="testPrompt('122')">测试提示词</button>
                  <button class="btn btn-history" @click="historyPrompt('122')">历史测试</button>
                </div>
              </div>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.ai_prompt_english"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
            <div class="write-txt" v-for="(item,index) in addObj.dimension_english" :key="'type1_'+index">
              <p class="write-title">维度{{(index+1)}}英文<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.dimension_english[index]"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
          </div>
          <div v-else-if="addObj.type == 2" style="display:block;">
            <div class="write-txt write-item">
              <div class="write-title">
                演讲完整报告提示词-闭眼--中文<span>*</span>
                <div class="write-btnlist">
                  <button class="btn btn-test" @click="testPrompt('212')">测试提示词</button>
                  <button class="btn btn-history" @click="historyPrompt('212')">历史测试</button>
                </div>
              </div>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.ai_prompt"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
            <div class="write-txt write-item">
              <div class="write-title">
                演讲完整报告提示词-非闭眼--中文<span>*</span>
                <div class="write-btnlist">
                  <button class="btn btn-test" @click="testPrompt('211')">测试提示词</button>
                  <button class="btn btn-history" @click="historyPrompt('211')">历史测试</button>
                </div>
              </div>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.ai_prompt_two"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
            <div class="write-txt write-item">
              <div class="write-title">
                演讲完整报告提示词-闭眼--英文<span>*</span>
                <div class="write-btnlist">
                  <button class="btn btn-test" @click="testPrompt('222')">测试提示词</button>
                  <button class="btn btn-history" @click="historyPrompt('222')">历史测试</button>
                </div>
              </div>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.ai_prompt_english"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
            <div class="write-txt write-item">
              <div class="write-title">
                演讲完整报告提示词-非闭眼--英文<span>*</span>
                <div class="write-btnlist">
                  <button class="btn btn-test" @click="testPrompt('221')">测试提示词</button>
                  <button class="btn btn-history" @click="historyPrompt('221')">历史测试</button>
                </div>
              </div>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.ai_prompt_two_english"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
          </div>
          <div v-else style="display:block;">
            <div class="write-txt write-item">
              <div class="write-title">
                演讲报告提示词--中文<span>*</span>
                <div class="write-btnlist">
                  <button class="btn btn-test" @click="testPrompt('31')">测试提示词</button>
                  <button class="btn btn-history" @click="historyPrompt('31')">历史测试</button>
                </div>
              </div>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.ai_prompt"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
            <div class="write-txt write-item">
              <div class="write-title">
                演讲报告提示词--英文<span>*</span>
                <div class="write-btnlist">
                  <button class="btn btn-test" @click="testPrompt('32')">测试提示词</button>
                  <button class="btn btn-history" @click="historyPrompt('32')">历史测试</button>
                </div>
              </div>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.ai_prompt_english"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="addObj.speech_type == 3 || addObj.speech_type == 4 || addObj.speech_type == 7" style="display:block;">
          <div v-if="addObj.type == 1" style="display:block;">
            <div class="write-txt write-item">
              <div class="write-title">
                演讲简易报告提示词--中文<span>*</span>
                <div class="write-btnlist">
                  <button class="btn btn-test" @click="testPrompt('111')">测试提示词</button>
                  <button class="btn btn-history" @click="historyPrompt('111')">历史测试</button>
                </div>
              </div>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.ai_prompt_simple"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
            <div class="write-txt write-item">
              <div class="write-title">
                演讲完整报告提示词--中文<span>*</span>
                <div class="write-btnlist">
                  <button class="btn btn-test" @click="testPrompt('112')">测试提示词</button>
                  <button class="btn btn-history" @click="historyPrompt('112')">历史测试</button>
                </div>
              </div>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.ai_prompt"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
            <div class="write-txt" v-for="(item,index) in addObj.dimension" :key="index">
              <p class="write-title">维度{{(index+1)}}中文<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.dimension[index]"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>

            <div class="write-txt write-item">
              <div class="write-title">
                演讲简易报告提示词--英文<span>*</span>
                <div class="write-btnlist">
                  <button class="btn btn-test" @click="testPrompt('121')">测试提示词</button>
                  <button class="btn btn-history" @click="historyPrompt('121')">历史测试</button>
                </div>
              </div>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.ai_prompt_simple_english"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
            <div class="write-txt write-item">
              <div class="write-title">
                演讲完整报告提示词--英文<span>*</span>
                <div class="write-btnlist">
                  <button class="btn btn-test" @click="testPrompt('122')">测试提示词</button>
                  <button class="btn btn-history" @click="historyPrompt('122')">历史测试</button>
                </div>
              </div>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.ai_prompt_english"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
            <div class="write-txt" v-for="(item,index) in addObj.dimension_english" :key="'type3_'+index">
              <p class="write-title">维度{{(index+1)}}英文<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.dimension_english[index]"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
          </div>
          <div v-else style="display:block;">
            <div class="write-txt write-item">
              <div class="write-title">
                演讲报告提示词--中文<span>*</span>
                <div class="write-btnlist">
                  <button class="btn btn-test" @click="testPrompt('31')">测试提示词</button>
                  <button class="btn btn-history" @click="historyPrompt('31')">历史测试</button>
                </div>
              </div>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.ai_prompt"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
            <div class="write-txt write-item">
              <div class="write-title">
                演讲报告提示词--英文<span>*</span>
                <div class="write-btnlist">
                  <button class="btn btn-test" @click="testPrompt('32')">测试提示词</button>
                  <button class="btn btn-history" @click="historyPrompt('32')">历史测试</button>
                </div>  
              </div>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.ai_prompt_english"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="addObj.speech_type == 6" style="display:block;">
          <div class="write-txt  write-item">
            <div class="write-title">
              提示词<span>*</span>
              <div class="write-btnlist">
                <button class="btn btn-test" @click="testPrompt('111')">测试提示词</button>
                <button class="btn btn-history" @click="historyPrompt('111')">历史测试</button>
              </div>
            </div>
            <div class="write-text">
              <textarea placeholder="" v-model="addObj.ai_prompt"></textarea>
              <span>最多输入30个以内的中文</span>
            </div>
          </div>
        </div>

        <div v-else-if="addObj.speech_type == 8" style="display:block;">
          <div class="write-txt write-item">
            <div class="write-title">
              演讲报告提示词<span>*</span>
              <div class="write-btnlist">
                <button class="btn btn-test" @click="testPrompt('112')">测试提示词</button>
                <button class="btn btn-history" @click="historyPrompt('112')">历史测试</button>
              </div>
            </div>
            <div class="write-text">
              <textarea placeholder="" v-model="addObj.ai_prompt"></textarea>
            </div>
          </div>
          <div class="write-txt" v-for="(item,index) in addObj.dimension" :key="index">
            <p class="write-title">维度{{(index+1)}}<span>*</span></p>
            <div class="write-text">
              <textarea placeholder="" v-model="addObj.dimension[index]"></textarea>
              <span>最多输入30个以内的中文</span>
            </div>
          </div>
        </div>

        <div v-else-if="addObj.speech_type == 9" style="display:block;">
          <div v-if="addObj.type == 1" style="display:block;">
            <div class="write-txt write-item">
              <div class="write-title">
                演讲简易报告提示词--中文<span>*</span>
                <div class="write-btnlist">
                  <button class="btn btn-test" @click="testPrompt('111')">测试提示词</button>
                  <button class="btn btn-history" @click="historyPrompt('111')">历史测试</button>
                </div>
              </div>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.ai_prompt_simple"></textarea>
              </div>
            </div>
            <div class="write-txt write-item">
              <div class="write-title">
                演讲完整报告提示词--中文<span>*</span>
                <div class="write-btnlist">
                  <button class="btn btn-test" @click="testPrompt('112')">测试提示词</button>
                  <button class="btn btn-history" @click="historyPrompt('112')">历史测试</button>
                </div>
              </div>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.ai_prompt"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
            <div class="write-txt" v-for="(item,index) in addObj.dimension" :key="index">
              <p class="write-title">维度{{(index+1)}}中文<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.dimension[index]"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>

            <div class="write-txt write-item">
              <div class="write-title">
                演讲简易报告提示词--英文<span>*</span>
                <div class="write-btnlist">
                  <button class="btn btn-test" @click="testPrompt('121')">测试提示词</button>
                  <button class="btn btn-history" @click="historyPrompt('121')">历史测试</button>
                </div>
              </div>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.ai_prompt_simple_english"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
            <div class="write-txt write-item">
              <div class="write-title">
                演讲完整报告提示词--英文<span>*</span>
                <div class="write-btnlist">
                  <button class="btn btn-test" @click="testPrompt('122')">测试提示词</button>
                  <button class="btn btn-history" @click="historyPrompt('122')">历史测试</button>
                </div>
              </div>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.ai_prompt_english"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
            <div class="write-txt" v-for="(item,index) in addObj.dimension_english" :key="'type9_'+index">
              <p class="write-title">维度{{(index+1)}}英文<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.dimension_english[index]"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
          </div>
          <div v-else style="display:block;">
            <div class="write-txt write-item">
              <div class="write-title">
                演讲报告提示词--中文<span>*</span>
                <div class="write-btnlist">
                  <button class="btn btn-test" @click="testPrompt('31')">测试提示词</button>
                  <button class="btn btn-history" @click="historyPrompt('31')">历史测试</button>
                </div>  
              </div>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.ai_prompt"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
            <div class="write-txt write-item">
              <div class="write-title">
                演讲报告提示词--英文<span>*</span>
                <div class="write-btnlist">
                  <button class="btn btn-test" @click="testPrompt('32')">测试提示词</button>
                  <button class="btn btn-history" @click="historyPrompt('32')">历史测试</button>
                </div>  
              </div>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.ai_prompt_english"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
          </div>
        </div>

        <div v-else style="display:block;">
          <div v-if="addObj.type == 1" style="display:block;">
            <div class="write-txt write-item">
              <div class="write-title">
                演讲简易报告提示词<span>*</span>
                <div class="write-btnlist">
                  <button class="btn btn-test" @click="testPrompt('111')">测试提示词</button>
                  <button class="btn btn-history" @click="historyPrompt('111')">历史测试</button>
                </div>
              </div>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.ai_prompt_simple"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
            <div class="write-txt write-item">
              <div class="write-title">
                演讲完整报告提示词<span>*</span>
                <div class="write-btnlist">
                  <button class="btn btn-test" @click="testPrompt('112')">测试提示词</button>
                  <button class="btn btn-history" @click="historyPrompt('112')">历史测试</button>
                </div>
              </div>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.ai_prompt"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
            <div class="write-txt" v-for="(item,index) in addObj.dimension" :key="index">
              <p class="write-title">维度{{(index+1)}}<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.dimension[index]"></textarea>
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
          </div>
          <div class="write-txt write-item" v-else>
            <div class="write-title">
              演讲报告提示词<span>*</span>
              <div class="write-btnlist">
                <button class="btn btn-test" @click="testPrompt('31')">测试提示词</button>
                <button class="btn btn-history" @click="historyPrompt('31')">历史测试</button>
              </div>
            </div>
            <div class="write-text">
              <textarea placeholder="" v-model="addObj.ai_prompt"></textarea>
              <span>最多输入30个以内的中文</span>
            </div>
          </div>
        </div>
        

        <!-- 视频--费曼--闭眼+非闭眼
        视频--其他--提示词

        文字--全部--简易+完整+维度

        音频--全部--提示词 -->

        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">保存</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
 
      <div class="organiza-txt testList" v-else-if="testType" v-loading="loading" :element-loading-text="loadTxt">
        <button class="btn btn-back" @click="historyHide('test')">返回</button>
        <div class="searchBox clear">
          <div class="search-item">
            <p>用户：</p>
            <input type="text" placeholder="请输入要搜索的会员名称" v-model="testObj.mobile">
          </div>
          <div class="search-btnBox">
            <button class="btn btn-search" @click="searchSub">搜索</button>
            <button class="btn btn-reset" @click="resetSub">重置</button>
          </div>
        </div>
        <div class="organiza-list test-list">
          <div class="titleList">
            <p v-for="item in testTitle" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in testData" v-bind:key="(index+1)" @click="testChoose(item,index)">
              <p :title="item.key" class="radio" :class="testID===index?'select':''">
                <span></span>
              </p>
              <p :title="item.account">{{item.account}}</p>
              <p :title="item.theme">{{item.theme}}</p>
              <p :title="item.total_score">{{item.total_score}}</p>
              <p :title="item.add_time">{{item.add_time}}</p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleTestCurrentChange"
              :current-page.sync="testObj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="testTotalPage">
            </el-pagination> 
          </div>
          
          <div class="test-btnBox" v-loading="loading">
            <button class="btn btn-sub" @click="testSub">确定</button>
            <button class="btn btn-close" @click="historyHide('test')">取消</button>
          </div>
        </div>
      </div>

      <div class="organiza-txt historyList" v-else-if="historyType">
        <button class="btn btn-back" @click="historyHide('history')">返回</button>
        <div class="organiza-list test-list">
          <div class="titleList">
            <p v-for="item in historyTitle" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in historyData" v-bind:key="(index+1)">
              <p :title="item.account">{{item.account}}</p>
              <p :title="item.add_time">{{item.add_time}}</p>
              <p :title="item.theme">{{item.theme}}</p>
              <p :title="item.add_time">
                <button title="查看" class="btn btn-revise" @click="historyDetail(item)">查看</button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleHistoryCurrentChange"
              :current-page.sync="historyObj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="historyTotalPage">
            </el-pagination> 
          </div>
          
          <!-- <div class="test-btnBox">
            <button class="btn btn-sub" @click="testSub">确定</button>
            <button class="btn btn-close">取消</button>
          </div> -->
        </div>
      </div>

       <div class="MobelBox" v-else-if="resultType">
        <button class="btn btn-back" @click="historyHide('result')">返回</button>
        <p></p>
        <div v-if="resultObj.speech_type == 1 || resultObj.speech_type == 3 || resultObj.speech_type==4 || resultObj.speech_type==7" style="display:block;">
          <div v-if="resultObj.type == 1" style="display:block;">
            <div v-if="resultObj.mode == '111'" style="display:block;">
              <div class="write-txt write-item">
                <div class="write-title">
                  演讲简易报告提示词--中文<span>*</span>
                </div>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.ai_prompt"></textarea>
                </div>
              </div>
            </div>
            <div v-if="resultObj.mode == '112'" style="display:block;">
              <div class="write-txt write-item">
                <div class="write-title">
                  演讲完整报告提示词--中文<span>*</span>
                </div>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.ai_prompt"></textarea>
                </div>
              </div>
              <div class="write-txt" v-for="(item,index) in resultObj.dimension" :key="index">
                <p class="write-title">维度{{(index+1)}}中文<span>*</span></p>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.dimension[index]"></textarea>
                  <span>最多输入30个以内的中文</span>
                </div>
              </div>
            </div>
            <div v-if="resultObj.mode == '121'" style="display:block;">
              <div class="write-txt write-item">
                <div class="write-title">
                  演讲简易报告提示词--英文<span>*</span>
                </div>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.ai_prompt"></textarea>
                </div>
              </div>
            </div>
            <div v-if="resultObj.mode == '122'" style="display:block;">
              <div class="write-txt write-item">
                <div class="write-title">
                  演讲完整报告提示词--英文<span>*</span>
                </div>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.ai_prompt"></textarea>
                </div>
              </div>
              <div class="write-txt" v-for="(item,index) in resultObj.dimension_english" :key="index">
                <p class="write-title">维度{{(index+1)}}中文<span>*</span></p>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.dimension_english[index]"></textarea>
                  <span>最多输入30个以内的中文</span>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="resultObj.type == 2" style="display:block;">
            <div v-if="resultObj.mode == '212'" style="display:block;">
              <div class="write-txt write-item">
                <div class="write-title">
                  演讲完整报告提示词-闭眼--中文<span>*</span>
                </div>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.ai_prompt"></textarea>
                </div>
              </div>
            </div>
            <div v-if="resultObj.mode == '211'" style="display:block;">
              <div class="write-txt write-item">
                <div class="write-title">
                  演讲完整报告提示词-非闭眼--中文<span>*</span>
                </div>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.ai_prompt"></textarea>
                </div>
              </div>
            </div>
            <div v-if="resultObj.mode == '222'" style="display:block;">
              <div class="write-txt write-item">
                <div class="write-title">
                  演讲完整报告提示词-闭眼--英文<span>*</span>
                </div>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.ai_prompt"></textarea>
                </div>
              </div>
            </div>
            <div v-if="resultObj.mode == '221'" style="display:block;">
              <div class="write-txt write-item">
                <div class="write-title">
                  演讲完整报告提示词-非闭眼--英文<span>*</span>
                </div>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.ai_prompt"></textarea>
                </div>
              </div>
            </div>
             <div v-if="resultObj.mode == '31'" style="display:block;">
              <div class="write-txt write-item">
                <div class="write-title">
                  演讲报告提示词--中文<span>*</span>
                </div>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.ai_prompt"></textarea>
                </div>
              </div>
            </div>
            <div v-if="resultObj.mode == '32'" style="display:block;">
              <div class="write-txt write-item">
                <div class="write-title">
                  演讲报告提示词--英文<span>*</span>
                </div>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.ai_prompt"></textarea>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="resultObj.type == 3" style="display:block;">
            <div v-if="resultObj.mode == '31'" style="display:block;">
              <div class="write-txt write-item">
                <div class="write-title">
                  演讲报告提示词--中文<span>*</span>
                </div>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.ai_prompt"></textarea>
                </div>
              </div>
            </div>
            <div v-if="resultObj.mode == '32'" style="display:block;">
              <div class="write-txt write-item">
                <div class="write-title">
                  演讲报告提示词--英文<span>*</span>
                </div>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.ai_prompt"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="resultObj.speech_type == 2 || resultObj.speech_type == 5" style="display:block;">
          <div v-if="resultObj.type == 1" style="display:block;">
            <div v-if="resultObj.mode == '111'" style="display:block;">
              <div class="write-txt write-item">
                <div class="write-title">
                  演讲简易报告提示词<span>*</span>
                </div>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.ai_prompt"></textarea>
                </div>
              </div>
            </div>
            <div v-if="resultObj.mode == '112'" style="display:block;">
              <div class="write-txt write-item">
                <div class="write-title">
                  演讲完整报告提示词<span>*</span>
                </div>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.ai_prompt"></textarea>
                </div>
              </div>
              <div class="write-txt" v-for="(item,index) in resultObj.dimension" :key="index">
                <p class="write-title">维度{{(index+1)}}中文<span>*</span></p>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.dimension[index]"></textarea>
                  <span>最多输入30个以内的中文</span>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="resultObj.type == 2" style="display:block;">
            <div v-if="resultObj.mode == '31'" style="display:block;">
              <div class="write-txt write-item">
                <div class="write-title">
                  演讲报告提示词<span>*</span>
                </div>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.ai_prompt"></textarea>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="resultObj.type == 3" style="display:block;">
            <div v-if="resultObj.mode == '31'" style="display:block;">
              <div class="write-txt write-item">
                <div class="write-title">
                  演讲报告提示词<span>*</span>
                </div>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.ai_prompt"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="resultObj.speech_type == 6" style="display:block;">
          <div v-if="resultObj.type == 1" style="display:block;">
            <div v-if="resultObj.mode == '111'" style="display:block;">
              <div class="write-txt write-item">
                <div class="write-title">
                  提示词<span>*</span>
                </div>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.ai_prompt"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="resultObj.speech_type == 8" style="display:block;">
          <div v-if="resultObj.mode == '112'" style="display:block;">
            <div class="write-txt write-item">
              <div class="write-title">
                演讲报告提示词<span>*</span>
              </div>
              <div class="write-text">
                <textarea placeholder="" v-model="resultObj.ai_prompt"></textarea>
              </div>
            </div>
            <div class="write-txt" v-for="(item,index) in resultObj.dimension" :key="index">
              <p class="write-title">维度{{(index+1)}}<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="" v-model="resultObj.dimension[index]"></textarea>
              </div>
            </div>
          </div>
        </div>

         <div v-if="resultObj.speech_type == 9" style="display:block;">
          <div v-if="resultObj.type == 1" style="display:block;">
            <div v-if="resultObj.mode == '111'" style="display:block;">
              <div class="write-txt write-item">
                <div class="write-title">
                  演讲简易报告提示词--中文<span>*</span>
                </div>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.ai_prompt"></textarea>
                </div>
              </div>
            </div>
            <div v-if="resultObj.mode == '112'" style="display:block;">
              <div class="write-txt write-item">
                <div class="write-title">
                  演讲完整报告提示词--中文<span>*</span>
                </div>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.ai_prompt"></textarea>
                </div>
              </div>
              <div class="write-txt" v-for="(item,index) in resultObj.dimension" :key="index">
                <p class="write-title">维度{{(index+1)}}中文<span>*</span></p>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.dimension[index]"></textarea>
                  <span>最多输入30个以内的中文</span>
                </div>
              </div>
            </div>
            <div v-if="resultObj.mode == '121'" style="display:block;">
              <div class="write-txt write-item">
                <div class="write-title">
                  演讲简易报告提示词--英文<span>*</span>
                </div>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.ai_prompt"></textarea>
                </div>
              </div>
            </div>
            <div v-if="resultObj.mode == '122'" style="display:block;">
              <div class="write-txt write-item">
                <div class="write-title">
                  演讲完整报告提示词--英文<span>*</span>
                </div>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.ai_prompt"></textarea>
                </div>
              </div>
              <div class="write-txt" v-for="(item,index) in resultObj.dimension_english" :key="index">
                <p class="write-title">维度{{(index+1)}}中文<span>*</span></p>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.dimension_english[index]"></textarea>
                  <span>最多输入30个以内的中文</span>
                </div>
              </div>
            </div>
          </div>
          <div v-else style="display:block;">
            <div v-if="resultObj.mode == '31'" style="display:block;">
              <div class="write-txt write-item">
                <div class="write-title">
                  演讲报告提示词--中文<span>*</span>
                </div>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.ai_prompt"></textarea>
                </div>
              </div>
            </div>
            <div v-if="resultObj.mode == '32'" style="display:block;">
              <div class="write-txt write-item">
                <div class="write-title">
                  演讲报告提示词--英文<span>*</span>
                </div>
                <div class="write-text">
                  <textarea placeholder="" v-model="resultObj.ai_prompt"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div style="display:block;">
          <div class="write-txt write-item">
            <p class="write-title">AI返回结果<span>*</span></p>
            <div class="write-text">
              <textarea placeholder="" v-model="resultData.ai_comment"></textarea>
            </div>
          </div>
        </div>

        <div class="write-btnBox" v-if="aiSource=='test'">
          <button class="btn btn-save" @click="saveSub">保存</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <img src="~@/assets/images/icon-add.png" alt="">
            <p>添加</p>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.type==1?'文字':item.type==2?'视频':'录音'">{{item.type==1?'文字':item.type==2?'视频':'录音'}}</p>
              <p :title="item.speech_type==1?'费曼练习':item.speech_type==2?'30秒黄金自我介绍':item.speech_type==3?'备稿演讲':item.speech_type==4?'即兴演讲':item.speech_type==5?'演讲评估':item.speech_type==6?'评估改稿-改稿':item.speech_type==7?'读稿':item.speech_type==8?'评估改稿-点评':'上传演讲'">{{item.speech_type==1?'费曼练习':item.speech_type==2?'30秒黄金自我介绍':item.speech_type==3?'备稿演讲':item.speech_type==4?'即兴演讲':item.speech_type==5?'演讲评估':item.speech_type==6?'评估改稿-改稿':item.speech_type==7?'读稿':item.speech_type==8?'评估改稿-点评':'上传演讲'}}</p>
              <p :title="item.ai_prompt">{{item.ai_prompt}}</p>
              <p :title="item.add_time">{{item.add_time}}</p>
              <p>
                <button title="修改" class="btn btn-revise" @click="buildSub(item)"></button>
                <button title="删除" class="btn btn-remove" @click="removeShow(item)"></button>
              </p>
            </div>
          </div>

          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
          
          
        </div>
      </div>

      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="ModelHide('remove')">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAiPromptList,saveAiPrompt,delAiPrompt,getAiPromptDetail ,getSpeechHistoryList,addAiPromptTest ,getAiPromptTestList,getAiPromptTestDetail} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "index",
  data() {
    return {
      navId:'16',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'提示词类型'},
        {id:3,title:'演讲方式'},
        {id:4,title:'演讲报告提示词'},
        {id:5,title:'添加时间'},
        {id:6,title:'操作'},
      ],
      testTitle:[
        {id:1,title:'勾选'},
        {id:2,title:'用户'},
        {id:3,title:'演讲标题'},
        {id:4,title:'点评分数'},
        {id:5,title:'演讲时间'},
      ],
      historyTitle:[
        {id:1,title:'用户'},
        {id:2,title:'测试时间'},
        {id:3,title:'类型'},
        {id:4,title:'测试结果'},
      ],
      dataList:[
      ],
      addType:'',
      removeType:false,
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:{
        speech_type:1,
        type:1,
        ai_prompt:'',
        dimension:['','','','',''],
        dimension_english : ['','','','',''],
      },
      totalPage:0,
      removeID:'',
      url:'',
      fileUrl:'/static/词库导入表.xlsx',
      typelist:[
        {id:1,title:'费曼练习'},
        {id:2,title:'30秒黄金自我介绍'},
        {id:3,title:'备稿演讲'},
        {id:4,title:'即兴演讲'},
        {id:5,title:'演讲评估'},
        {id:6,title:'评估改稿-改稿'},
        {id:7,title:'读稿'},
        {id:8,title:'评估改稿-点评'},
        {id:9,title:'上传演讲'},
      ],
      promptlist:[
        {id:1,title:'文本'},
        {id:2,title:'视频'},
        {id:3,title:'录音'},
      ],
      wordType:false,
      wordObj:{
        words:[
          {title:'',keyword:'',language:1}
        ]
      },
      testType:false,
      testObj:{
        speech_type:'',
        type:'',
        page:1,
        rows:10,
      },
      loading:false,
      loadTxt:'',
      testData:[],
      testTotalPage:0,
      testID:'',
      resultType:false,
      resultData:'',
      resultObj:{
        speech_id:'',
        speech_type:'',
        type:'',
        mode:'',
        ai_prompt:'',
      },
      historyObj:{
        speech_type:'',
        type:'',
        mode:'',
        page:1,
        rows:10,
      },
      historyData:'',
      historyType:false,
      historyTotalPage:0,
      modelType:'',
      aiSource:'',
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.url = this.$refs.navBox.url;
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    handleTestCurrentChange(){
      this.getTestList();
    },

    handleHistoryCurrentChange(){
      this.getHistoryList();
    },

    async getList(){
      var that = this;
      try {
        const response = await getAiPromptList(this.obj,this.token);
        if(response.code == 200){
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addSub(){
      var that = this;
      this.addType = 'add';
      this.addObj.dimension = ['','','','',''];
      this.modelType = this.addType;
    },

    async buildSub(e){
      var that = this;
      try {
        const response = await getAiPromptDetail({id:e.id},this.token);
        if(response.code == 200){
          that.addObj =  response.data;
          that.addType = 'edit';
          that.modelType = this.addType;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    removeShow(e){
      this.removeID = e.id;
      this.removeType = true;
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delAiPrompt({id:this.removeID},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.getList();
          that.ModelHide('remove');       
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    ModelHide(type){
      var that = this;
      if(type == 'remove'){
        that.removeType = false;
        that.removeID = '';
      }
    },

    async saveSub(){
      var that = this;
      if(this.addObj.ai_prompt == ''){
        that.$message('请输入提示词！');
        return false;
      }
      try {
        const response = await saveAiPrompt(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.addType = '';
      this.addObj = {
        speech_type:1,
        type:1,
        ai_prompt:'',
      };
    },

    speechSub(){
      var that = this;
      if(that.addObj.speech_type == 1 || that.addObj.speech_type == 3 || that.addObj.speech_type == 4 || that.addObj.speech_type == 7 || that.addObj.speech_type == 9){
        if(that.addObj.type == 1){
          that.addObj.dimension_english = ['','','','',''];
        } else {
          delete that.addObj.dimension_english;
        }
        that.promptlist = [
          {id:1,title:'文本'},
          {id:2,title:'视频'},
          {id:3,title:'录音'},
        ]
      } else if(that.addObj.speech_type == 6 || that.addObj.speech_type == 8){
        that.promptlist = [
          {id:1,title:'文本'},
        ];
        that.addObj.type = 1;
      } else {
        delete that.addObj.dimension_english;
        that.promptlist = [
          {id:1,title:'文本'},
          {id:2,title:'视频'},
          {id:3,title:'录音'},
        ]
      }
    },

    typeSub(){
      var that = this;
      if(that.addObj.type == 1 || that.addObj.type == 9){
        that.addObj.dimension_english = ['','','','',''];
      } else {
        delete that.addObj.dimension_english;
      }
    },

    searchSub(){

    },

    resetSub(){

    },

    async testPrompt(mode){
      var that = this;
      this.aiSource = 'test';
      if(this.addObj.type == 1){
        if(this.addObj.speech_type == 1 || this.addObj.speech_type == 3 || this.addObj.speech_type == 4 || this.addObj.speech_type == 7 || this.addObj.speech_type == 9){
          if(mode == '111'){
            if(this.addObj.ai_prompt_simple == '' || !this.addObj.ai_prompt_simple){
              that.$message('请填写演讲简易报告提示词--中文');
              return;
            } else {
              that.resultObj.ai_prompt = that.addObj.ai_prompt_simple;
            }
          }
          if(mode == '112'){
            if(this.addObj.ai_prompt == '' || !this.addObj.ai_prompt){
              that.$message('请填写演讲完整报告提示词--中文');
              return;
            } else {
              that.resultObj.ai_prompt = that.addObj.ai_prompt;
            }
            for(var i = 0;i < that.addObj.dimension.length; i++){
              if(that.addObj.dimension[i] == ''){
                that.$message('请填写维度'+(i+1)+'中文');
                return;
              } else {
                that.resultObj.dimension = that.addObj.dimension;
              }
            }
          }
          if(mode == '121'){
            if(this.addObj.ai_prompt_simple_english == '' || !this.addObj.ai_prompt_simple_english){
              that.$message('请填写演讲简易报告提示词--英文');
              return;
            } else {
              that.resultObj.ai_prompt = that.addObj.ai_prompt_simple_english;
              
            }
          }
          if(mode == '122'){
            if(this.addObj.ai_prompt_english == '' || !this.addObj.ai_prompt_english){
              that.$message('请填写演讲完整报告提示词--英文');
              return;
            } else {
              that.resultObj.ai_prompt = that.addObj.ai_prompt_english;
            }
            for(var i = 0;i < that.addObj.dimension_english.length; i++){
              if(that.addObj.dimension_english[i] == ''){
                that.$message('请填写维度'+(i+1)+'英文');
                return;
              } else {
                that.resultObj.dimension_english = that.addObj.dimension_english;
              }
            }
          }
        } else if(this.addObj.speech_type == 2 || this.addObj.speech_type == 5){
          if(mode == '111'){
            if(this.addObj.ai_prompt_simple == '' || !this.addObj.ai_prompt_simple){
              that.$message('演讲简易报告提示词');
              return;
            } else {
              that.resultObj.ai_prompt = that.addObj.ai_prompt_simple;
            }
          }
          if(mode == '112'){
            if(this.addObj.ai_prompt == '' || !this.addObj.ai_prompt){
              that.$message('演讲完整报告提示词');
              return;
            } else {
              that.resultObj.ai_prompt = that.addObj.ai_prompt;
            }
            for(var i = 0;i < that.addObj.dimension.length; i++){
              if(that.addObj.dimension[i] == ''){
                that.$message('请填写维度'+(i+1));
                return;
              } else {
                that.resultObj.dimension = that.addObj.dimension;
              }
            }
          }
          
        } else if(this.addObj.speech_type == 6){
          if(mode == '111'){
            if(this.addObj.ai_prompt == '' || !this.addObj.ai_prompt){
              that.$message('请填写提示词');
              return;
            } else {
              that.resultObj.ai_prompt = that.addObj.ai_prompt;
            }
          }
        } else if(this.addObj.speech_type == 8){
          if(mode == '112'){
            if(this.addObj.ai_prompt == '' || !this.addObj.ai_prompt){
              that.$message('请填写演讲报告提示词');
              return;
            } else {
              that.resultObj.ai_prompt = that.addObj.ai_prompt;
            }
            for(var i = 0;i < that.addObj.dimension.length; i++){
              if(that.addObj.dimension[i] == ''){
                that.$message('请填写维度'+(i+1));
                return;
              } else {
                that.resultObj.dimension = that.addObj.dimension;
              }
            }
          }
        }
      } else if(this.addObj.type == 2){
        if(this.addObj.speech_type == 1){
          if(mode == '212'){
            if(this.addObj.ai_prompt == '' || !this.addObj.ai_prompt){
              that.$message('请填写演讲完整报告提示词-闭眼--中文');
              return;
            } else {
              that.resultObj.ai_prompt = that.addObj.ai_prompt;
            }
          }
          if(mode == '211'){
            if(this.addObj.ai_prompt_two == '' || !this.addObj.ai_prompt_two){
              that.$message('请填写演讲完整报告提示词-非闭眼--中文');
              return;
            } else {
              that.resultObj.ai_prompt = that.addObj.ai_prompt_two;
            }
          }
          if(mode == '222'){
            if(this.addObj.ai_prompt_english == '' || !this.addObj.ai_prompt_english){
              that.$message('请填写演讲完整报告提示词-闭眼--英文');
              return;
            } else {
              that.resultObj.ai_prompt = that.addObj.ai_prompt_english;
            }
          }
          if(mode == '221'){
            if(this.addObj.ai_prompt_two_english == '' || !this.addObj.ai_prompt_two_english){
              that.$message('请填写演讲完整报告提示词-闭眼--中文');
              return;
            } else {
              that.resultObj.ai_prompt = that.addObj.ai_prompt_two_english;
            }
          }
        } else if(this.addObj.speech_type == 2 || this.addObj.speech_type == 5){
          if(mode == '31'){
            if(this.addObj.ai_prompt == '' || !this.addObj.ai_prompt){
              that.$message('请填写演讲报告提示词');
              return;
            } else {
              that.resultObj.ai_prompt = that.addObj.ai_prompt;
            }
          }
        } else if(this.addObj.speech_type == 3 || this.addObj.speech_type == 4 || this.addObj.speech_type == 7 || this.addObj.speech_type == 9){
          if(mode == '31'){
            if(this.addObj.ai_prompt == '' || !this.addObj.ai_prompt){
              that.$message('请填写演讲报告提示词');
              return;
            } else {
              that.resultObj.ai_prompt = that.addObj.ai_prompt;
            }
          }
          if(mode == '32'){
            if(this.addObj.ai_prompt_english == '' || !this.addObj.ai_prompt_english){
              that.$message('请填写演讲报告提示词');
              return;
            } else {
              that.resultObj.ai_prompt = that.addObj.ai_prompt_english;
            }
          }
        }
      } else if(that.addObj.type == 3){
        if(this.addObj.speech_type == 1){
          if(mode == '31'){
            if(this.addObj.ai_prompt == '' || !this.addObj.ai_prompt){
              that.$message('请填写演讲报告提示词--中文');
              return;
            } else {
              that.resultObj.ai_prompt = that.addObj.ai_prompt;
            }
          }
          if(mode == '32'){
            if(this.addObj.ai_prompt_english == '' || !this.addObj.ai_prompt_english){
              that.$message('请填写演讲报告提示词--英文');
              return;
            } else {
              that.resultObj.ai_prompt = that.addObj.ai_prompt_english;
            }
          }
        } else if(this.addObj.speech_type == 2 || this.addObj.speech_type == 5){
          if(mode == '31'){
            if(this.addObj.ai_prompt == '' || !this.addObj.ai_prompt){
              that.$message('请填写演讲报告提示词');
              return;
            } else {
              that.resultObj.ai_prompt = that.addObj.ai_prompt;
            }
          }
        } else if(this.addObj.speech_type == 3 || this.addObj.speech_type == 4 || this.addObj.speech_type == 7 || this.addObj.speech_type == 9){
          if(mode == '31'){
            if(this.addObj.ai_prompt == '' || !this.addObj.ai_prompt){
              that.$message('请填写演讲报告提示词');
              return;
            } else {
              that.resultObj.ai_prompt = that.addObj.ai_prompt;
            }
          }
          if(mode == '32'){
            if(this.addObj.ai_prompt_english == '' || !this.addObj.ai_prompt_english){
              that.$message('请填写演讲报告提示词');
              return;
            } else {
              that.resultObj.ai_prompt = that.addObj.ai_prompt_english;
            }
          }
        }
      };
      this.testObj.type = this.addObj.type;
      this.testObj.speech_type = this.addObj.speech_type;
      this.getTestList(mode);
    },

    async getTestList(mode){
      var that = this;
      try {
        const response = await getSpeechHistoryList(this.testObj,this.token);
        if(response.code == 200){
          that.testData = response.data.list;
          that.testTotalPage = response.data.total_page;  
          that.testType = true;
          that.$refs.scrollContainer.scrollTo({
            top: 0,
            behavior: "auto", // 平滑滚动
          });
          that.addType = '';
          that.resultObj.mode = mode;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },
    
    async historyPrompt(mode){
      var that = this;
      this.aiSource = 'history';
      this.historyObj.speech_type = this.addObj.speech_type;
      this.historyObj.type = this.addObj.type;
      this.historyObj.mode = mode;
      this.getHistoryList();
    },

    async getHistoryList(){
      var that = this;
      try {
        const response = await getAiPromptTestList(this.historyObj,this.token);
        if(response.code == 200){
          that.historyData = response.data.list;
          that.historyTotalPage = response.data.total_page;  
          that.historyType = true;
          that.addType = '';
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    testChoose(item,index){
      this.testID = index;
      this.resultObj.speech_id = item.speech_id;
      this.resultObj.speech_type = this.addObj.speech_type;
      this.resultObj.type = this.addObj.type;
    },

    async testSub(){
      var that = this;
      if(this.loading){
        return false;
      }
      this.loading = true;
      this.loadTxt = 'ai生成中，请稍后';
      try {
        const response = await addAiPromptTest(this.resultObj,this.token);
        if(response.code == 200){
          that.resultType = true;
          that.testType = false;
          that.resultData = response.data;
          that.loading = false;
          that.loadTxt = '';
        } else {
          that.$message(response.msg);
          that.loading = false;
          that.loadTxt = ''
        }
      } catch (error) {
        that.$message(error);
        that.loading = false;
        that.loadTxt = ''
      }
    },

    historyHide(type){
      if(type == 'test'){
        this.addType = this.modelType;
        this.testType = false;
        this.testID = '';
      } else if(type == 'result'){
        if(this.aiSource == 'test'){
          this.resultType = false;
          this.testType = true;
        } else {
          this.resultType = false;
          this.historyType = true;
        }
      } else if(type == 'history'){
        this.historyType = false;
        this.addType = this.modelType;
      }
    },
    
    async historyDetail(e){
      var that = this;
      try {
        const response = await getAiPromptTestDetail({id:e.id,speech_type:this.addObj.speech_type},this.token);
        if(response.code == 200){
          that.resultType = true;
          that.historyType = false;
          that.resultData = {
            ai_comment:response.data.ai_comment
          };
          that.resultObj = {
            speech_id:'',
            speech_type:response.data.speech_type,
            type:response.data.type,
            mode:response.data.mode,
            ai_prompt:response.data.ai_prompt,
          };
          if(response.data.dimension!=null || response.data.dimension.length>0){
            that.resultObj.dimension = response.data.dimension;
          }
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    }
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 6 );
  }

  
  .historyList .dataList .listItem p, 
  .historyList .organiza-list p{
    width: calc( 100% / 4 );
  }
  
  .historyList .dataList .listItem p .btn-remove,
  .historyList .dataList .listItem p .btn-revise{
    background-image: none;
    width: auto;
    height: auto;
  }

  .historyList .dataList .listItem p .btn-revise{
    color: #6E2FFF;
  }

  .btn-remove,
  .btn-revise{
    background-image: url(~@/assets/images/btn-revise.png);
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    display: inline-block;
    vertical-align: top;
  }

  .btn-remove{
    background-image: url(~@/assets/images/btn-remove.png);
    margin-left: 50px;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
    height: calc( 100% - 80px );
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 65px;
    background-color: #F5F5F5;
    border-radius: 16px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }
  
  .MobelBox input{
    height: 45px;
    width: 200px;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: right;
  }

  .write-btnBox .btn{
    width: 120px;
    height: 56px;
    line-height: 56px;
    border-radius: 16px;
    color: #fff;
    background-color: #6E2FFF;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 40px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

  .msgBox .title {
    text-align: center;
    margin-bottom: 50px;
  }

  .btn-import{
    display: inline-block;
    vertical-align: top;
  }

  .organiza-txt>>>.el-upload{
    width: 100%;
    display: block;
  }

  .organiza-txt>>>.el-button--small span{
    width: 100%;
    text-align: center;
    display: block;
  }

  .organiza-txt>>>.el-button--primary{
    background-color: transparent;
    border: none;
    font-size: 15px;
  }

  .btn-word-add{
    color: #6E2FFF;
    border: solid 1px #6E2FFF;
    border-radius: 8px;
    padding: 11px 34px;
    display: block;
    margin-top: 30px;
    font-size: 18px;
  }

  .btn-word-remove{
    background-color: #E2231A;
    border-radius: 8px;
    color: #fff;
    box-sizing: border-box;
    padding: 11px 52px;
    display: inline-block;
    vertical-align: middle;
    font-size: 18px;
  }

  .wordBox{
    height: calc( 100% - 100px );
  }

  .wordBox .word-item{
    margin-bottom: 20px;
    display: block;
    background-color: #fff;
    box-sizing: border-box;
    padding: 40px 30px;
  }

  .MobelBox .write-item .write-text{
    display: block;
    margin: 20px 0 0;
  }

  .MobelBox .write-item .write-btnlist{
    display: inline-block;
    vertical-align: top;
    margin-left: 30px;
  }

  .MobelBox .write-item .write-btnlist .btn{
    width: 117px;
    height: 40px;
    font-size: 18px;
    color: #fff;
    background-color: #6E2FFF;
    border-radius: 6px;
    display: inline-block;
    vertical-align: top;
    margin: 0 10px;
    border: solid 1px transparent;
  }

  .MobelBox .write-item .write-btnlist .btn.btn-history{
    color: #6E2FFF;
    background-color: transparent;
    border: solid 1px #6E2FFF;
  }

  .MobelBox .write-item .write-text textarea{
    height: 300px;
  }

  .testList .dataList .listItem p, 
  .testList .organiza-list p{
    width: calc( 100% / 5 );
  }

  .testList .dataList .listItem p.radio span{
    width: 20px;
    height: 20px;
    background-color: #D9D9D9;
    border-radius: 4px;
    display: block;
  }

  .testList .dataList .listItem p.select span{
    background-color: #6098F2;
  }

  .testList .dataList .listItem p.select span::before{
    content: '✔';
    width: 20px;
    height: 20px;
    display: block;
    color: #ffff;
    margin: 0 5px;
  }

  .testList .searchBox{
    margin-top: 10px;
  }

  .testList .btn-back{
    margin: 10px 0 0;
  }

  .testList .dataList{
    height: calc( 100% - 240px );
  }

  .testList .test-btnBox{
    font-size: 0;
    display: block;
    text-align: right;
    margin-top: 80px;
    padding-right: 40px;
    box-sizing: border-box;
  }

  .testList .test-btnBox .btn{
    box-sizing: border-box;
    padding: 10px 30px;
    border-radius: 16px;
    display: inline-block;
    vertical-align: top;
    background-color: #6E2FFF;
    color: #fff;
    font-size: 18px;
  }

  .testList .test-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/prompt/index.vue